<template>
  <el-container>
    <el-aside class="main-aside">
      <el-container>
        <el-header class="left-houselist">
          <el-input placeholder="请输入小区名称" v-model="likeData"></el-input>
          <el-button type="primary" @click="getHousingList()">查询</el-button>
        </el-header>
        <el-main>
          <el-table
            :data="tableData"
            :show-header="false"
            ref="tablesure"
            highlight-current-row
            default-expand-all
            @row-click="houseClick"
            row-key="userId"
            :tree-props="{ children: 'users' }"
          >
            <el-table-column prop="userName" label="名字"> </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </el-aside>
    <el-main class="main-main">
      <el-container>
        <el-header>
          <h3>异常数据</h3>
        </el-header>
        <el-main>
          <p style="width:300px">
            <el-input placeholder="请输入姓名或电话" v-model="keywords" class="input-with-select">
              <el-button type="primary" @click="getAllAbnormal()" slot="append" icon="el-icon-search">查询</el-button>
            </el-input>
          </p>
          <p class="point-title">异常数据请根据信息联系用户核实处理</p>
          <el-table
            :data="allAbnormalList"
            border
            :header-cell-style="{ background: '#409EFF', color: '#fff' }"
          >
            <el-table-column
              prop="userName"
              label="姓名"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="phoneNum"
              label="电话"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="上报时间"
              align="center"
            ></el-table-column>
            <el-table-column label="错误类型" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.types == 1">认证信息有误</el-tag>
                <el-tag type="success" v-if="scope.row.types == 2"
                  >业主区域有误</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status == 0"
                  type="primary"
                  @click="changeStatus(scope.row)"
                  >是否已处理</el-button
                >
                <el-button
                  v-if="scope.row.status == 1"
                  type="danger"
                  @click="removeAbnormalcord(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-main>
          <!-- 分页 -->
        <el-footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="rowCount"
          >
          </el-pagination>
        </el-footer>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      tableData: [], //小区列表
      likeData: "", //模糊查询
      unitId: "", //小区ID
      allAbnormalList: [], //异常数据list
      pagesize:20,
      currentPage:1,
      rowCount:0,
      keywords:'',
    };
  },
  computed: {
    ...mapGetters(["userinfo"])
  },
  created() {
    this.getHousingList();
  },
  methods: {
       /*
     **  @description 分页
     **  @param {}
     **  @return
     **  @author shipingan
     */
    handleSizeChange(val) {
      this.pagesize = val;
      this.getAllAbnormal();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAllAbnormal();
    },
    getHousingList() {
      let url = "/dapi/u/likeSelectUserInfo";
      let params = {
        uid: this.userinfo.uid,
        likeData: this.likeData
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.tableData = [];
          data.data.map(item => {
            if (item.userRoleCode == 3 || item.userRoleCode == 9) {
              this.tableData.push(item);
            }
            if (item.users && item.users.length > 0) {
              let users = item.users.filter(
                k => k.userRoleCode == 3 || k.userRoleCode == 9
              );
              item.users = users;
              this.tableData.push(item);
            }
          });
          // this.tableData = data.data;
          // this.$refs.tablesure.setCurrentRow(this.tableData[0]);
          this.$nextTick(() => {
            this.$refs.tablesure.setCurrentRow(this.tableData[0]);
          });
          if (this.tableData[0].users != undefined) {
            if (
              this.tableData[0].users != "" &&
              this.tableData[0].users.length > 0
            ) {
              this.houseClick(this.tableData[0].users[0]);
              return;
            }
          }
          this.houseClick(this.tableData[0]);
        }
      });
    },
    houseClick(row) {
      this.unitId = row.userId;
      this.getAllAbnormal();
    },
    /*
     **  @description 获取异常数据
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getAllAbnormal() {
      let url = "/dapi/u/queryErrUser";
      let params = { unitId: this.unitId,currentPage:this.currentPage,pageSize:this.pagesize,keywords:this.keywords };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        console.log(res);
        let data = res.data;
        if (data.status == 200) {
          this.allAbnormalList = data.data;
          this.rowCount = data.rowCount
        } else {
          this.$message.error(data.message);
        }
      });
    },
    /*
     **  @description 处理异常
     **  @param {}
     **  @return
     **  @author shipingan
     */
    changeStatus(row) {
      this.$confirm("请确定已经处理异常, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let url = "/dapi/u/fixErrUser";
          let params = {
            errorUid: row.errorUid
          };
          this.$axios.post(url, this.$qs.stringify(params)).then(res => {
            let data = res.data;
            if (data.status == 200) {
              this.$message({
                type: "success",
                message: "处理成功"
              });
              this.getAllAbnormal();
            } else {
              this.$message.error(data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    /*
     **  @description 删除已处理异常
     **  @param {}
     **  @return
     **  @author shipingan
     */
    removeAbnormalcord(row) {
      this.$confirm("是否确定删除已处理异常, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let url = "/dapi/u/deleteErrUser";
          let params = {
            errorUid: row.errorUid
          };
          this.$axios.post(url, this.$qs.stringify(params)).then(res => {
            let data = res.data;
            if (data.status == 200) {
              this.$message({
                type: "success",
                message: "删除成功"
              });
              this.getAllAbnormal();
            } else {
              this.$message.error(data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  }
};
</script>
<style lang="less" scoped>
@box-shadow: 0px 0px 10px #ccc;
.el-container {
  height: 100%;
  .main-aside {
    box-shadow: @box-shadow;
    .left-houselist {
      display: flex;
      box-sizing: border-box;
      padding: 16px 20px;
      justify-content: space-between;
      box-shadow: @box-shadow;
      .el-input {
        width: 180px;
        margin-right: 10px;
      }
    }
    .el-main {
      padding-top: 10px;
    }
  }
  .main-main {
    padding: 0;
    .el-header {
      text-align: left;
      box-shadow: @box-shadow;
      min-width: 400px;
    }
    .point-title {
      text-align: left;
      color: red;
      margin-top: 0;
    }
  }
}
</style>
